<template>
  <router-view />
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  async mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const lngParam = urlParams.get("lng");
    const lngStore = this.$store.state.settings.lang;

    const language = lngParam || lngStore || "de";
    this.$store.commit("setLang", language.toLowerCase());
    this.$root.$vuetify.lang.current = language.toLowerCase();
    this.$root.$i18n.locale = language.toLowerCase();

    addEventListener(
      "leavepictureinpicture",
      () => {
        const videos = Array.from(document.getElementsByTagName("video"));
        videos.forEach((video) => video.pause());
      },
      false
    );
  },
});
</script>
